<div class="add-container">
    <div class="d-flex justify-content-between align-items-center">
        <h1 class="add-title m-0 p-0">Generează un nou borderou</h1>
        <button class="action-buttons-side" (click)="closeDialog()">x</button>
    </div>
    <ng-container *ngIf="!showSelectedDocs">
        <h3 class="m-0">Identificare Documente - Registratură</h3>
        <mat-divider class="divider-section"></mat-divider>
        <br>
        <div class="row">
            <div class="col-md-6 mb-3">
                <button type="button" style="background-color:#f39c12; border-color: #e08e0b; color: #fff"
                    class="btn-general" (click)="changeView()">
                    <i class="fa fa-angle-double-left"></i>
                    <span>Vizualizare documente adăugate/selectate</span>
                </button>
            </div>
            <div class="col-md-6 mb-3 d-flex justify-content-end">
                <button type="button" style="background-color:#00c0ef; border-color: #00acd6; color: #fff"
                    class="btn-general" (click)="refresh()">
                    <i class="fa fa-refresh"></i>
                    <span> Resetare Căutare</span>
                </button>
            </div>
        </div>

        <form [formGroup]="form">
            <div class="row">
                <div class="col-md-6">
                    <div class="divider-container">
                        <div class="line"></div>
                        <span class="text">ORIGINE/OPERATOR</span>
                        <div class="line"></div>
                    </div>
                    <div class="row">
                        <div class="col-md-12">
                            <mat-form-field class="w-100">
                                <mat-label>Instituție/Direcție</mat-label>
                                <input matInput [formControl]="directiiOriginControl"
                                    [matAutocomplete]="autoDirectiiOrigin" (blur)="onDirectiiOriginBlur()" />
                                <mat-icon matSuffix class="opacity-50 search-icon">search</mat-icon>
                                <mat-autocomplete #autoDirectiiOrigin="matAutocomplete"
                                    [displayWith]="displayDirectiiOrigin"
                                    (optionSelected)="onDirectiiOriginChange($event.option.value)">
                                    <mat-option *ngIf="filteredDirectiiOrigin.length === 0" disabled>
                                        Nu au fost găsite rezultate
                                    </mat-option>
                                    <mat-option *ngFor="let directie of filteredDirectiiOrigin" [value]="directie">
                                        {{ directie.name }}
                                    </mat-option>
                                </mat-autocomplete>
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-12">
                            <mat-form-field class="w-100">
                                <mat-label>Compartiment/Departament</mat-label>
                                <input matInput [formControl]="compartimenteOriginControl"
                                    [matAutocomplete]="autoCompartimenteOrigin" (blur)="onCompartimenteOriginBlur()" />
                                <mat-icon matSuffix class="opacity-50 search-icon">search</mat-icon>
                                <mat-autocomplete #autoCompartimenteOrigin="matAutocomplete"
                                    [displayWith]="displayCompartimenteOrigin"
                                    (optionSelected)="onCompartimenteOriginSelected($event.option.value)">
                                    <mat-option *ngIf="showCompartimenteOriginMessage" disabled>
                                        <span
                                            *ngIf="!compartimenteOriginControl.value || compartimenteOriginControl.value.length < 2">
                                            Vă rugăm să introduceți 2 caractere sau mai multe
                                        </span>
                                        <span
                                            *ngIf="isCompartimenteOriginLoading && compartimenteOriginControl.value && compartimenteOriginControl.value.length >= 2">Căutare...</span>
                                        <span
                                            *ngIf="!isCompartimenteOriginLoading && compartimenteOriginLoadComplete && compartimenteOrigin.length === 0 && compartimenteOriginControl.value && compartimenteOriginControl.value.length >= 2">
                                            Nu au fost găsite rezultate
                                        </span>
                                    </mat-option>

                                    <mat-option *ngFor="let compartiment of compartimenteOrigin" [value]="compartiment">
                                        {{ compartiment.name }}
                                    </mat-option>
                                </mat-autocomplete>
                            </mat-form-field>
                        </div>
                    </div>
                    <button (click)="toggleOperatoriList()" class="btn-general mb-3 w-100" [ngStyle]="!showOperatoriList ? {'background-color': '#f4f4f4', 'border':'1px solid #ddd','color': '#444'} 
                    : {'background-color': '#00c0ef', 'border':'1px solid #00acd6', 'color':'#fff'}">
                        <span *ngIf="!showOperatoriList"><i class="fa fa-user"></i> Căutare după Operator</span>
                        <span *ngIf="showOperatoriList"><i class="fa fa-users"></i> Căutare după Multipli
                            Operatori</span>
                    </button>
                    <div *ngIf="!showOperatoriList" class="row">
                        <div class="col-md-12">
                            <mat-form-field class="w-100">
                                <mat-label>Operator</mat-label>
                                <mat-select formControlName="origin_user_id"
                                    (selectionChange)="onOperatoriOriginChange($event.value)">
                                    <mat-option [value]="-1">-- Alegeți --</mat-option>
                                    <mat-option *ngFor="let operator of filteredOperatoriOrigin" [value]="operator.id">
                                        {{ operator.name }}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                    </div>
                    <div *ngIf="showOperatoriList">
                        <div>
                            <strong>Operator(i)</strong>
                            <mat-checkbox [checked]="allOperatoriAdded" [color]="'primary'"
                                (change)="addAllOperatori($event.checked)">
                                Selectează toți
                            </mat-checkbox>
                        </div>
                        <ul class="operatori-list ps-0 mb-0">
                            <li class="ms-3" *ngIf="operatoriList.length > 0">-- Alegeți --</li>
                            <li *ngFor="let operator of operatoriList">
                                <mat-checkbox [(ngModel)]="operator.added" [ngModelOptions]="{standalone: true}"
                                    [color]="'primary'" (ngModelChange)="updateAllOperatoriAdded()">
                                    {{operator.name}}
                                </mat-checkbox>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="divider-container">
                        <div class="line"></div>
                        <span class="text">DESTINAȚIE</span>
                        <div class="line"></div>
                    </div>
                    <div class="row">
                        <div class="col-md-12">
                            <mat-form-field class="w-100">
                                <mat-label>Instituție/Direcție</mat-label>
                                <input matInput [formControl]="directiiDestinatieControl"
                                    [matAutocomplete]="autoDirectiiDestinatie" (blur)="onDirectiiDestinatieBlur()" />
                                <mat-icon matSuffix class="opacity-50 search-icon">search</mat-icon>
                                <mat-autocomplete #autoDirectiiDestinatie="matAutocomplete"
                                    [displayWith]="displayDirectiiDestinatie"
                                    (optionSelected)="onDirectiiDestinatieChange($event.option.value)">
                                    <mat-option *ngIf="filteredDirectiiDestinatie.length === 0" disabled>
                                        Nu au fost găsite rezultate
                                    </mat-option>
                                    <mat-option *ngFor="let directie of filteredDirectiiDestinatie" [value]="directie">
                                        {{ directie.name }}
                                    </mat-option>
                                </mat-autocomplete>
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-12">
                            <mat-form-field class="w-100">
                                <mat-label>Compartiment/Departament</mat-label>
                                <input matInput [formControl]="compartimenteDestinatieControl"
                                    [matAutocomplete]="autoCompartimenteDestinatie"
                                    (blur)="onCompartimenteDestinatieBlur()" />
                                <mat-icon matSuffix class="opacity-50 search-icon">search</mat-icon>
                                <mat-autocomplete #autoCompartimenteDestinatie="matAutocomplete"
                                    [displayWith]="displayCompartimenteDestinatie"
                                    (optionSelected)="onCompartimenteDestinatieSelected($event.option.value)">
                                    <mat-option *ngIf="showCompartimenteDestinatieMessage" disabled>
                                        <span
                                            *ngIf="!compartimenteDestinatieControl.value || compartimenteDestinatieControl.value.length < 2">
                                            Vă rugăm să introduceți 2 caractere sau mai multe
                                        </span>
                                        <span
                                            *ngIf="isCompartimenteDestinatieLoading && compartimenteDestinatieControl.value && compartimenteDestinatieControl.value.length >= 2">Căutare...</span>
                                        <span
                                            *ngIf="!isCompartimenteDestinatieLoading && compartimenteDestinatieLoadComplete && compartimenteDestinatie.length === 0 && compartimenteDestinatieControl.value && compartimenteDestinatieControl.value.length >= 2">
                                            Nu au fost găsite rezultate
                                        </span>
                                    </mat-option>

                                    <mat-option *ngFor="let compartiment of compartimenteDestinatie"
                                        [value]="compartiment">
                                        {{ compartiment.name }}
                                    </mat-option>
                                </mat-autocomplete>
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-12">
                            <mat-form-field class="w-100">
                                <mat-label>Operator</mat-label>
                                <mat-select formControlName="destinatie_user_id"
                                    (selectionChange)="onOperatoriDestinatieChange($event.value)">
                                    <mat-option [value]="-1">-- Alegeți --</mat-option>
                                    <mat-option *ngFor="let operator of filteredOperatoriDestinatie"
                                        [value]="operator.id">
                                        {{ operator.name }}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                    </div>
                </div>
            </div>

            <div class="divider-container">
                <div class="line"></div>
                <span class="text">IDENTIFICARE DOCUMENT(E)</span>
                <div class="line"></div>
            </div>
            <div class="row">
                <div class="col-md-6">
                    <mat-form-field>
                        <mat-label>Număr Document(Intrare/Intern)</mat-label>
                        <input matInput type="number" formControlName="document_number" />
                    </mat-form-field>
                </div>
                <div class="col-md-3">
                    <mat-form-field>
                        <mat-label>Dată Document(e) de la:</mat-label>
                        <input matInput [max]="today" [matDatepicker]="dateInputStartPicker"
                            formControlName="date_input_start" readonly (focus)="dateInputStartPicker.open()" />
                        <mat-hint>ZZ/LL/AAAA</mat-hint>
                        <mat-datepicker-toggle matIconSuffix [for]="dateInputStartPicker"></mat-datepicker-toggle>
                        <mat-datepicker #dateInputStartPicker></mat-datepicker>
                    </mat-form-field>
                </div>
                <div class="col-md-3">
                    <mat-form-field>
                        <mat-label>Dată Document(e) până la:</mat-label>
                        <input matInput [min]="today" [matDatepicker]="dateInputEndPicker"
                            formControlName="date_input_end" readonly (focus)="dateInputEndPicker.open()" />
                        <mat-hint>ZZ/LL/AAAA</mat-hint>
                        <mat-datepicker-toggle matIconSuffix [for]="dateInputEndPicker"></mat-datepicker-toggle>
                        <mat-datepicker #dateInputEndPicker></mat-datepicker>
                    </mat-form-field>
                </div>
            </div>
        </form>

        <button (click)="searchDocuments()" class="btn-general w-100 my-2"
            style="background-color: #3c8dbc; border-color: #367fa9; color: #fff;">
            <mat-icon matSuffix class="opacity-50 search-icon">search</mat-icon>
            <span>Caută documente</span>
        </button>

        <button (click)="addAllDocumentsToBorderou()" class="btn-general w-100 my-2"
            style="background-color: #f39c12; border-color: #e08e0b; color: #fff;">
            <mat-icon matSuffix class="opacity-50 search-icon">search</mat-icon>
            <span>Adaugă toate documentele în Borderou</span>
        </button>

        <div class="divider-container">
            <div class="line"></div>
            <span class="text">REZULTATE - DOCUMENTE - FILTRE APLICATE</span>
            <div class="line"></div>
        </div>

        <table class="table table-condensed">
            <thead>
                <tr>
                    <th>
                        <span *ngIf="!selectedDocuments.length">#</span>
                        <button *ngIf="selectedDocuments.length" class="btn btn-sm btn-small p-1 my-1"
                            [ngClass]="selectedDocumentsNr !== selectedDocuments.length ? 'btn-success' : 'btn-danger'"
                            (click)="selectAllDocuments()">
                            {{ selectedDocumentsNr !== selectedDocuments.length ? 'Toate' : 'Deselectare'}}
                        </button>
                    </th>
                    <th>Crt.</th>
                    <th>Nr. Reg.</th>
                    <th>Dată Înregistrare</th>
                    <th>Cale Acces/Ieșire</th>
                    <th>Proveniență</th>
                    <th>Tip Document</th>
                    <th>Destinatar</th>
                    <th>Nr. Extern</th>
                    <th>Term. Rez.</th>
                    <th>Documente în original?</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngIf="!selectedDocuments.length">
                    <td colspan="11" class="text-center py-2">
                        <strong><i>Lipsă înregistrări</i></strong>
                    </td>
                </tr>
                <tr *ngFor="let row of selectedDocuments; let i = index">
                    <td style="min-width: 80px">
                        <button class="btn btn-sm btn-small p-1 my-1"
                            [ngClass]="row.selected ? 'btn-success' : 'btn-danger'" (click)="selectDocument(i)">
                            {{ !row.selected ? 'Alege' : 'Selectat' }}
                        </button>
                    </td>
                    <td>{{ i + 1 }}</td>
                    <td>{{ row.reg_number || 'n/a' }}</td>
                    <td>
                        <div>{{ row.created_at ? (row.created_at | date : "dd.MM.yyyy HH:mm" : "ro")
                            : 'n/a' }}</div>
                        <div><i class="fa fa-user"></i> {{ row.origin_user_name || 'n/a' }}</div>
                    </td>
                    <td>{{ row.category || 'n/a' }}</td>
                    <td>{{ row.entity || 'n/a' }}</td>
                    <td>{{ row.document_tip_name || 'n/a' }}</td>
                    <td>
                        <div><i class="fa fa-book"></i> {{ row.destination_directie_name || 'n/a'}}</div>
                        <div><i class="fa fa-cubes"></i> {{ row.destination_compartiment_name ||'n/a' }}</div>
                        <div><i class="fa fa-user"></i> {{ row.destination_user_name || 'n/a' }}</div>
                    </td>
                    <td>{{ row.extern_numar || 'n/a' }}</td>
                    <td>{{ row.last_day_work || 'n/a' }}</td>
                    <td>{{ row.dosar_original === 1 ? 'DA' : 'NU' }}</td>
                </tr>
            </tbody>
        </table>

        <button *ngIf="selectedDocuments.length > 0" (click)="addDocumentsToBorderou()" class="btn-general w-100 my-2"
            style="background-color: #00a65a;  border-color: #008d4c; color: #fff;">
            <span>Adaugă documente în Borderou ({{selectedDocumentsNr}})</span>
        </button>
    </ng-container>

    <ng-container *ngIf="showSelectedDocs">
        <h3 class="m-0">Vizualizare Documente Selectate - Borderou - Registratură</h3>
        <mat-divider class="divider-section"></mat-divider>
        <br>

        <div class="row">
            <div class="col-md-6 mb-3">
                <button type="button" style="background-color: #3c8dbc; border-color: #367fa9; color: #fff;"
                    class="btn-general" (click)="refreshBorderouDocs()">
                    <i class="fa fa-refresh"></i>
                    <span>Resetare</span>
                </button>
            </div>
            <div class="col-md-6 mb-3 d-flex justify-content-end">
                <button type="button" style="background-color:#f39c12; border-color: #e08e0b; color: #fff"
                    class="btn-general" (click)="changeView()">
                    <span>Adăugare documente borderou</span>
                    <i class="fa fa-angle-double-right"></i>
                </button>
            </div>
        </div>

        <div class="divider-container mb-3">
            <div class="line"></div>
            <!-- <span class="text"></span> -->
            <div class="line"></div>
        </div>

        <div class="row">
            <div class="col-md-6">
                <table class="table table-condensed boxed-section">
                    <tbody>
                        <tr class="boxed-header">
                            <td colspan="2" class="text-center"><strong>ORIGINE</strong></td>
                        </tr>
                        <tr>
                            <td><strong>Direcție/Instituție</strong></td>
                            <td>{{ form.get('origin_directie_name')?.value || 'n/a' }}</td>
                        </tr>
                        <tr>
                            <td><strong>Compartiment/Departament</strong></td>
                            <td>{{ form.get('origin_compartiment_name')?.value || 'n/a' }}</td>
                        </tr>
                        <tr>
                            <td><strong>Operator</strong></td>
                            <td>{{ form.get('origin_user_name')?.value || 'n/a' }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="col-md-6">
                <table class="table table-condensed boxed-section">
                    <tbody>
                        <tr class="boxed-header">
                            <td colspan="2" class="text-center"><strong>DESTINAȚIE</strong></td>
                        </tr>
                        <tr>
                            <td><strong>Direcție/Instituție</strong></td>
                            <td>{{ form.get('destinatie_directie_name')?.value || 'n/a' }}</td>
                        </tr>
                        <tr>
                            <td><strong>Compartiment/Departament</strong></td>
                            <td>{{ form.get('destinatie_compartiment_name')?.value || 'n/a' }}</td>
                        </tr>
                        <tr>
                            <td><strong>Operator</strong></td>
                            <td>{{ form.get('destinatie_user_name')?.value || 'n/a' }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <div *ngIf="destinatariTableData.length" class="row">
            <div class="col-md-12">
                <table class="table table-condensed boxed-section">
                    <tbody>
                        <tr class="boxed-header">
                            <td colspan="3" class="text-center"><strong>DESTINATARI DOCUMENTE</strong></td>
                        </tr>
                        <tr>
                            <td><strong>#</strong></td>
                            <td><strong>Compartiment/Departament/Direcție</strong></td>
                            <td><strong>Număr documente</strong></td>
                        </tr>
                        <tr *ngFor="let row of destinatariTableData; let i = index">
                            <td>{{ i + 1 }}</td>
                            <td>{{ row.destination_compartiment_name ? row.destination_compartiment_name :
                                row.destination_directie_name }}</td>
                            <td>{{ row.total }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <button (click)="storeBorderou()" class="btn-general w-100 mb-3"
            style="background-color: #00a65a;  border-color: #008d4c; color: #fff;">
            <span>Generează Borderou cu ({{borderouDocuments.length}}) documente</span>
        </button>

        <table class="table table-condensed">
            <thead>
                <tr>
                    <th>#</th>
                    <th>Crt.</th>
                    <th>Nr. Reg.</th>
                    <th>Dată Înregistrare</th>
                    <th>Cale Acces/Ieșire</th>
                    <th>Proveniență</th>
                    <th>Tip Document</th>
                    <th>Destinatar</th>
                    <th>Nr. Extern</th>
                    <th>Term. Rez.</th>
                    <th>Documente în original?</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngIf="!borderouDocuments.length">
                    <td colspan="11" class="text-center py-2">
                        <strong><i>Lipsă înregistrări</i></strong>
                    </td>
                </tr>
                <ng-container *ngFor="let row of borderouDocuments; let i = index">
                    <tr *ngIf="row.selected">
                        <td style="min-width: 70px">
                            <button class="btn btn-sm btn-small p-1 my-1 btn-danger" (click)="deleteBorderouDoc(i)">
                                <i class="fa fa-trash"></i>
                            </button>
                        </td>
                        <td>{{ i + 1 }}</td>
                        <td>{{ row.reg_number || 'n/a' }}</td>
                        <td>
                            <div>{{ row.created_at ? (row.created_at | date : "dd.MM.yyyy HH:mm" : "ro")
                                : 'n/a' }}</div>
                            <div><i class="fa fa-user"></i> {{ row.origin_user_name || 'n/a' }}</div>
                        </td>
                        <td>{{ row.category || 'n/a' }}</td>
                        <td>{{ row.entity || 'n/a' }}</td>
                        <td>{{ row.document_tip_name || 'n/a' }}</td>
                        <td>
                            <div><i class="fa fa-book"></i> {{ row.destination_directie_name || 'n/a'}}</div>
                            <div><i class="fa fa-cubes"></i> {{ row.destination_compartiment_name ||'n/a' }}</div>
                            <div><i class="fa fa-user"></i> {{ row.destination_user_name || 'n/a' }}</div>
                        </td>
                        <td>{{ row.extern_numar || 'n/a' }}</td>
                        <td>{{ row.last_day_work || 'n/a' }}</td>
                        <td>{{ row.dosar_original === 1 ? 'DA' : 'NU' }}</td>
                    </tr>
                </ng-container>
            </tbody>
        </table>
    </ng-container>

    <div class="section-spinner position-absolute" *ngIf="isLoading">
        <div class="spinner position-absolute top-50 start-50 translate-middle">
            <mat-spinner></mat-spinner>
            <h3 class="mt-2">{{ helper.dialogConfig.generalMessages.pleaseWait }}</h3>
        </div>
    </div>
</div>